import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=5568e906&scoped=true"
import script from "./TwoFactor.vue?vue&type=script&lang=js"
export * from "./TwoFactor.vue?vue&type=script&lang=js"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&id=5568e906&prod&lang=css"
import style1 from "./TwoFactor.vue?vue&type=style&index=1&id=5568e906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568e906",
  null
  
)

export default component.exports